<div class="locales-selector" ClickOutside (clickOutside)="open = false">
  <div class="locales-selector__header" (click)="open = !open">
    <div class="locales-selector__current-locale">
      <img [src]="'/assets/svg/lang/' + language.current + '.svg'" [alt]="language?.current">
    </div>
    <i class="icon-arrow"></i>
  </div>
  <div class="locales-selector__options" [ngClass]="{open: open}">
    @for (lang of env.env.languageList; track $index) {
      <div class="locales-selector__options-item"
        (click)="changeLanguage(lang?.short)"
        [ngClass]="{'active': lang.short === language.current}"
        >
        <span>{{lang?.short}}</span>
        <img [src]="'/assets/svg/lang/' + lang?.short + '.svg'" [alt]="lang?.short">
      </div>
    }
  </div>
</div>
